"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoLinesAnnotationsController = exports.OneLineSummaryAnnotationController = exports.OneLineEachPointAnnotationController = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _valuationUtilsComponent = require("@cian/valuation-utils-component");
var _constants = require("./constants");
var _annotations = require("./annotations.positioners");
var _getCustoms = require("./getCustoms");
var _datasetUtils = require("./datasetUtils");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class AnnotationsController {
  constructor() {
    (0, _defineProperty2.default)(this, "baseAnnotationOptions", void 0);
    this.baseAnnotationOptions = {
      type: 'label',
      padding: _constants.Y_PADDING,
      borderRadius: 2,
      font: {
        size: 14
      },
      textAlign: 'start'
    };
  }
}
class TwoLinesAnnotationsController extends AnnotationsController {
  constructor(props, annotationsOptions) {
    super();
    (0, _defineProperty2.default)(this, "props", void 0);
    (0, _defineProperty2.default)(this, "annotationsOptions", void 0);
    (0, _defineProperty2.default)(this, "annotationsPositioners", void 0);
    (0, _defineProperty2.default)(this, "annotations", void 0);
    this.props = props;
    this.annotationsOptions = annotationsOptions;
    this.annotationsPositioners = new _annotations.TwoLinesAnnotationPositioners();
    this.annotations = {};
    this.init();
  }
  init() {
    const c = (0, _getCustoms.getCustoms)(this.props);
    this.annotations.estimationPrice = _objectSpread(_objectSpread({}, this.baseAnnotationOptions), {}, {
      xValue: this.annotationsPositioners.getXEstimationPriceValue,
      yValue: this.annotationsPositioners.getYEstimationPriceValue,
      position: {
        x: 'end',
        y: (0, _utils.ensureScriptable)(this.annotationsPositioners.estimationValuePositionY)
      },
      backgroundColor: c.BG_COLOR,
      color: _constants.BLUE_COLOR,
      content: ctx => {
        const {
          estimationPricePoint
        } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
        const pointPrice = (0, _valuationUtilsComponent.getPrettyPrice)((0, _utils.ensurePoint)(estimationPricePoint).price);
        return `Оценка Циан: ${pointPrice}`;
      },
      xAdjust: -5,
      yAdjust: this.annotationsPositioners.estimationPriceYAdjust
    });
    this.annotations.offerPrice = _objectSpread(_objectSpread({}, this.baseAnnotationOptions), {}, {
      xValue: this.annotationsPositioners.getXOfferPriceValue,
      yValue: this.annotationsPositioners.getYOfferPriceValue,
      position: {
        x: 'end',
        y: (0, _utils.ensureScriptable)(this.annotationsPositioners.offerValuePositionY)
      },
      backgroundColor: c.BG_COLOR,
      color: _constants.RED_COLOR,
      content: ctx => {
        const {
          offerPricePoint
        } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
        const pointPrice = (0, _valuationUtilsComponent.getPrettyPrice)((0, _utils.ensurePoint)(offerPricePoint).price);
        return `Цена в объявлении: ${pointPrice}`;
      },
      xAdjust: -5,
      yAdjust: this.annotationsPositioners.offerPriceYAdjust
    });
    this.annotationsOptions.annotations = this.annotations;
  }
}
exports.TwoLinesAnnotationsController = TwoLinesAnnotationsController;
class OneLineSummaryAnnotationController extends AnnotationsController {
  constructor(props, annotationsOptions) {
    super();
    (0, _defineProperty2.default)(this, "props", void 0);
    (0, _defineProperty2.default)(this, "annotationsOptions", void 0);
    (0, _defineProperty2.default)(this, "annotationsPositioners", void 0);
    (0, _defineProperty2.default)(this, "annotations", void 0);
    this.props = props;
    this.annotationsOptions = annotationsOptions;
    this.annotationsPositioners = new _annotations.OneLineAnnotationPositioners();
    this.annotations = {};
    this.init();
  }
  init() {
    const c = (0, _getCustoms.getCustoms)(this.props);
    this.annotations.summaryAnnotation = _objectSpread(_objectSpread({}, this.baseAnnotationOptions), {}, {
      xValue: this.annotationsPositioners.getXVal,
      yValue: this.annotationsPositioners.getYVal,
      position: {
        x: 'end',
        y: (0, _utils.ensureScriptable)(this.annotationsPositioners.getPositionY)
      },
      backgroundColor: c.BG_COLOR,
      color: ctx => {
        const {
          estimationPricePoint
        } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
        return estimationPricePoint ? _constants.BLUE_COLOR : _constants.RED_COLOR;
      },
      content: ctx => {
        const {
          estimationPricePoint,
          offerPricePoint
        } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
        const point = estimationPricePoint || (0, _utils.ensurePoint)(offerPricePoint);
        const title = estimationPricePoint ? 'Оценка Циан' : 'Цена в объявлении';
        const pointPrice = (0, _valuationUtilsComponent.getPrettyPrice)(point.price);
        return `${title}: ${pointPrice}`;
      },
      xAdjust: -5,
      yAdjust: (0, _utils.ensureScriptable)(this.annotationsPositioners.getYAdjust)
    });
    this.annotationsOptions.annotations = this.annotations;
  }
}
exports.OneLineSummaryAnnotationController = OneLineSummaryAnnotationController;
class OneLineEachPointAnnotationController extends AnnotationsController {
  constructor(props, annotationsOptions) {
    super();
    (0, _defineProperty2.default)(this, "props", void 0);
    (0, _defineProperty2.default)(this, "annotationsOptions", void 0);
    (0, _defineProperty2.default)(this, "annotations", void 0);
    this.props = props;
    this.annotationsOptions = annotationsOptions;
    this.annotations = {};
    this.init();
  }
  init() {
    const {
      offerPrice,
      estimatedPrice
    } = this.props.data;
    const srcDataset = estimatedPrice || offerPrice;
    srcDataset.forEach((datasetItem, i) => {
      this.annotations[`annotation_${i}`] = _objectSpread(_objectSpread({}, this.baseAnnotationOptions), {}, {
        display: ctx => {
          if (this.props.isDesktop) {
            return !ctx.chart.isHover;
          }
          return !ctx.chart.isHover && [0, srcDataset.length - 1].includes(i);
        },
        xValue: () => datasetItem.date,
        yValue: () => datasetItem.price,
        position: {
          x: (0, _utils.ensureScriptable)(() => {
            if (i === 0) {
              return 'start';
            } else if (i === srcDataset.length - 1) {
              return 'end';
            }
            return 'center';
          }),
          y: 'end'
        },
        backgroundColor: 'rgba(255,255,255,0.9)',
        color: ctx => {
          const {
            estimationPricePoint
          } = (0, _datasetUtils.getLinesEndPoints)((0, _utils.ensureCtx)(ctx));
          return estimationPricePoint ? _constants.BLUE_COLOR : _constants.RED_COLOR;
        },
        content: () => (0, _valuationUtilsComponent.getPrettyPrice)(datasetItem.price),
        yAdjust: -5
      });
    });
    this.annotationsOptions.annotations = this.annotations;
  }
}
exports.OneLineEachPointAnnotationController = OneLineEachPointAnnotationController;